/* Copyright (c) 2020 Lenderblock Corporation */

const blenderTransfersToPublicKey = '0x308296910feC066BF5539C44d5D6EeC1De55099F'
export default blenderTransfersToPublicKey;